import React from "react";
import { PageContentProps } from "@/types/modules/post/components";
import styles from "@/styles/post.module.css";
import { MainLayout } from "@/components/layout/MainLayout";
import { useParsedContent } from "@/hooks/useParsedContent";
import Head from "next/head";

export const PageContent: React.FC<PageContentProps> = ({ page }) => {
  const [parsedContent] = useParsedContent(page?.content, true, undefined, true);

  const isSSR = typeof window === "undefined";

  return (
    <MainLayout ignoreAds={true}>
      <Head>
        <title>{page?.yoastHeadJson?.title ?? `${page.title} - Magazín Reportér`}</title>
        <meta
          property="og:title"
          content={page?.yoastHeadJson?.og_title ?? `${page.title} - Magazín Reportér`}
          key="og:title"
        />
        <meta
          name="description"
          content={page?.yoastHeadJson?.description ?? page.excerpt ?? "Jdeme po tom, co vás baví číst"}
          key="description"
        />
        <meta
          property="og:description"
          content={page?.yoastHeadJson?.og_description ?? page.excerpt ?? "Jdeme po tom, co vás baví číst"}
          key="og:description"
        />
        <meta property="og:locale" content={page?.yoastHeadJson?.og_locale ?? "cs_CZ"} key="og:locale" />
        <meta property="og:type" content={page?.yoastHeadJson?.og_type ?? "website"} key="og:type" />
        <meta property="og:url" content={page?.yoastHeadJson?.og_url ?? page.link} key="og:url" />
        {page.date && (
          <meta
            property="og:updated_time"
            content={new Date(page.date.split(" ")[0]).toISOString()}
            key="og:updated_time"
          />
        )}
        {page?.thumbnail?.full?.url && <meta property="og:image" content={page?.thumbnail?.full?.url} key="og:image" />}
        {page?.yoastHeadJson?.schema && (
          <script
            key="head-json-ld"
            id="meta-schema"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(page.yoastHeadJson.schema) }}
          ></script>
        )}
      </Head>
      {/* This is a poor try to prevent hydratation error but it's not working */}
      {!isSSR && (
        <div className={styles.postContentContainer}>
          <h1 className={styles.h1}>{page.title}</h1>
          {parsedContent}
        </div>
      )}
    </MainLayout>
  );
};
